import React, { useEffect, useState } from 'react';
import { UserType } from '../../../types';
import TextInputDesktop from "../atomicDesignDesktop/TextInputDesktop";
import SelectInputDesktop from "../atomicDesignDesktop/SelectInputDesktop";
import formatPhoneNumber from "../../../utils/functions/formatPhoneNumber";
import VPAutoService from "../../../services/VPAuto/VPAutoService";
import { useTranslation } from "react-i18next";
import toTitleCase from "../../../utils/functions/toTitleCase";
import { useAuthContext } from "../../../contexts/AuthContext";


const SignUpPageDesktopProPanel1 = () => {
	const {
		userInfo,
		setUserInfo,
		isFirstPanelValidated,
		validateFirstPanel,
		openedPanel,
		setOpenedPanel
	} = useAuthContext();
	const { t } = useTranslation();
	const [optionsListHowDidYouKnowUs, setOptionsListHowDidYouKnowUs] = useState<{
		value: string,
		label: string
	}[]>([]);
	
	const [wrongFields, setWrongFields] = useState({
		email: false,
		lastName: false,
		firstName: false,
		phone: false,
		function: false,
	});
	
	useEffect(() => {
		VPAutoService.readOptionsListHowDidYouKnowUs(UserType.PRO)
		.then((response) => {
			const optionsList = response.data.value.split(';').map((value: string) => ({
				value,
				label: value
			}));
			setOptionsListHowDidYouKnowUs([
				{ value: '', label: '' },
				...optionsList,
			]);
		}).catch(() => {});
	}, []);
	
	const validateFields = () => {
		const newWrongFields = {
			email: !userInfo.contact.email,
			lastName: !userInfo.contact.lastName,
			firstName: !userInfo.contact.firstName,
			phone: !userInfo.contact.phone,
			function: !userInfo.contact.function,
		};
		setWrongFields(newWrongFields);
		return Object.values(newWrongFields).every((value) => !value);
	};
	
	return (
		<div
			style={{
				marginTop: 39,
				width: 1601,
				height: openedPanel === 'coordinates and contact' ? 290 : 30,
				background: '#FFFFFF',
				borderRadius: 20,
				position: 'relative',
				padding: 24,
				paddingBottom: openedPanel === 'coordinates and contact' ? 96 : 24,
				boxShadow: '0px 1px 6px #00000029',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					cursor: 'pointer',
				}}
				onClick={() => setOpenedPanel(openedPanel === 'coordinates and contact' ? '' : 'coordinates and contact')}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						gap: 8,
					}}
				>
					{isFirstPanelValidated ? (
						<img
							src="/images/check-2.svg"
							alt="check"
							style={{
								width: 26,
								height: 26,
								marginBottom: -3,
								marginLeft: -8,
							}}
						/>
					) : (
						<div style={{ width: 18 }}/>
					)}
					<div
						style={{
							fontSize: 25,
							fontWeight: 'bold',
							display: 'flex',
							alignItems: 'center',
						}}
					>
						{t('firstPanel:contact_info')}
					</div>
				</div>
				
				{openedPanel === 'coordinates and contact' ? (
					<img
						src="/images/chevron-down.svg"
						alt="chevron-down"
						style={{ width: 20, height: 20 }}
					/>
				) : (
					<img
						src="/images/chevron-right.svg"
						alt="chevron-right"
						style={{ width: 24, height: 24 }}
					/>
				)}
			</div>
			{openedPanel === 'coordinates and contact' && (
				<>
					<div
						style={{
							margin: '28px 30px 0 30px',
							display: 'grid',
							gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
							columnGap: 32,
							rowGap: 24,
							alignItems: 'start',
						}}
					>
						<div style={{ minWidth: 0 }}>
							<TextInputDesktop
								width={426}
								type="text"
								value={userInfo.contact.email}
								title={t('firstPanel:email')}
								mandatory
								disabled
								onChange={() => {}}
								wrong={wrongFields.email}
								wrongMessage={t('firstPanel:fill_this_field')}
							/>
						</div>
						<div style={{ minWidth: 0 }}>
							<TextInputDesktop
								width={426}
								type="text"
								value={userInfo.contact.lastName}
								placeholder="Dupont"
								title={t('firstPanel:last_name')}
								mandatory
								onChange={(e) =>
									setUserInfo({
										...userInfo,
										contact: {
											...userInfo.contact,
											lastName: toTitleCase(e.target.value),
										},
									})
								}
								wrong={wrongFields.lastName}
								wrongMessage={t('firstPanel:fill_this_field')}
							/>
						</div>
						<div style={{ minWidth: 0 }}>
							<TextInputDesktop
								width={426}
								type="text"
								value={userInfo.contact.firstName}
								placeholder="Jean"
								title={t('firstPanel:first_name')}
								mandatory
								onChange={(e) =>
									setUserInfo({
										...userInfo,
										contact: {
											...userInfo.contact,
											firstName: toTitleCase(e.target.value),
										},
									})
								}
								wrong={wrongFields.firstName}
								wrongMessage={t('firstPanel:fill_this_field')}
							/>
						</div>

						<div style={{ minWidth: 0 }}>
							<TextInputDesktop
								width={426}
								type="text"
								value={formatPhoneNumber(userInfo.contact.phone)}
								placeholder="06 12 34 56 78"
								title={t('firstPanel:phone')}
								mandatory
								onChange={(e) =>
									setUserInfo({
										...userInfo,
										contact: {
											...userInfo.contact,
											phone: formatPhoneNumber(e.target.value),
										},
									})
								}
								wrong={wrongFields.phone}
								wrongMessage={t('firstPanel:fill_this_field')}
							/>
						</div>
						<div style={{ minWidth: 0 }}>
							<SelectInputDesktop
								width={426}
								value={userInfo.contact.function}
								placeholder={t('firstPanel:function_placeholder')}
								options={[
									{ value: '', label: '' },
									{ value: 'Acheteur', label: t('firstPanel:function_options:buyer') },
									{ value: 'Administratif', label: t('firstPanel:function_options:admin') },
									{ value: 'Chef des ventes VO', label: t('firstPanel:function_options:sales_manager') },
									{ value: 'Comptabilité', label: t('firstPanel:function_options:accounting') },
									{ value: 'Gérant', label: t('firstPanel:function_options:manager') },
									{ value: 'Vendeur', label: t('firstPanel:function_options:seller') },
									{ value: 'Autre', label: t('firstPanel:function_options:other') },
								]}
								title={t('firstPanel:function')}
								mandatory
								onChange={(e) =>
									setUserInfo({
										...userInfo,
										contact: {
											...userInfo.contact,
											function: e.target.value,
										},
									})
								}
								wrong={wrongFields.function}
								wrongMessage={t('firstPanel:fill_this_field')}
							/>
						</div>
						<div style={{ minWidth: 0 }}>
							{userInfo.company.countryCode === 'FR' ? (
								<SelectInputDesktop
									width={426}
									value={userInfo.contact.howDidYouKnowUs}
									options={optionsListHowDidYouKnowUs}
									title={t('firstPanel:how_did_you_know_us')}
									placeholder="LinkedIn"
									onChange={(e) =>
										setUserInfo({
											...userInfo,
											contact: {
												...userInfo.contact,
												howDidYouKnowUs: e.target.value,
											},
										})
									}
								/>
							) : (
								<div style={{ width: 426 }}></div>
							)}
						</div>
					</div>
					<button
						style={{
							position: 'absolute',
							bottom: 22,
							right: 24,
							padding: '0px 25px',
							height: 43,
							borderRadius: 10,
							backgroundColor: '#FF4D00',
							color: '#FFFFFF',
							border: 'none',
							fontSize: 19,
							fontWeight: 'bold',
							cursor: 'pointer',
							textTransform: 'uppercase',
						}}
						onClick={() => {
							if (validateFields()) {
								validateFirstPanel();
							}
						}}
					>
						{t('firstPanel:validate_button')}
					</button>
				</>
			)}
		</div>
	);
};

export default SignUpPageDesktopProPanel1;
